import { ApiEndpointBuilder } from "@/services/api/types";
import { InvoiceListItem } from "../types";

const getInvoices = (builder: ApiEndpointBuilder) => {
  return builder.query<InvoiceListItem[], void>({
    query: () => ({
      url: "/checkout/invoices",
      method: "GET",
    }),
  });
};

export default getInvoices;
